import Layout from "../include/layout";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { myroutes } from "../../routes/webroute";
import { checkAuthenticate } from "../app/providers/authSlice";
import ClassesService from "../classe/ClassesService";
import $ from 'jquery'
import GrillestarifairesService from "./GrillestarifairesService";
import CategoriesgrillestarifairesService from "../categoriesgrillestarifaires/CategoriesgrillestarifairesService";
import TypesinscriptionsService from "../typesinscriptions/TypesinscriptionsService";
import Filarial from "../include/filarial";
import Joi from "joi-browser";

export default function GrillestarifairesCreate() {
    const token = useSelector(state => state.auth.token)
    const activeLink = "GRILLES TARIFAIRES"
    const [errors, setErrors] = useState({});

    //Elément du formulaire d'ajout de grille tarifaire
    const [classes, setClasses] = useState([]);
    //const [classeId, setClasseId] = useState('');
    //const [categoriegrilletarifaireId, setCategoriegrilletarifaireId] = useState('');
    const [categoriesgrillestarifaires, setCategoriesgrillestarifaires] = useState([]);
    //const [typeinscriptionId, setTypeInscriptionId] = useState('');
    const [typeInscriptions, setTypeInscriptions] = useState([]);
    //const [montantGrilleTarifaire, setMontantGrilleTarifaire] = useState('');
    //const [isRequired, setIsRequired] = useState(false);
    //End

    //declaration des variables pour le form d'enregistrement
    const [addFormData, setAddFormData] = useState({
        categoriegrilletarifaireId: '',
        typeinscriptionId: '',
        classeId: '',
        montantGrilleTarifaire: '',
        isRequired: false,
    });

    const navigate = useNavigate()

    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    //####GESTION DES REGLES DE VALIDATIONS ###########///
    const schemaAddData = {
        classeId: Joi.number().integer().min(1).required().empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { number: 'vous devez renseignez un nombre' },
            },
        }).label("Classe"),

        categoriegrilletarifaireId: Joi.number().integer().min(1).required().empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { number: 'vous devez renseignez un nombre' },
            },
        }).label("Categorie"),

        typeinscriptionId: Joi.number().integer().empty('').options({
            language: {
                //any: { required: 'le champ est obligatoire' },
                //string: { number: 'vous devez renseignez un nombre' },
            },
        }).label("Type inscription"),

        montantGrilleTarifaire: Joi.number().integer().min(1).required().empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { number: 'vous devez renseignez un nombre' },
            },
        }).label("Montant"),

        isRequired: Joi.boolean().empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
            },
        }).label("A payer obligatoirement"),
    };


    //####END GESTION DES REGLES DE VALIDATIONS ###########///

    //Gérer les changements sur les formulaires d'ajout
    const handleChange = (event) => {
        //console.log(name)
        const { name, value } = event.target;

        setAddFormData({ ...addFormData, [name]: value });

        /**
        * Masquer le champ Type Inscription si la categorie sélectionnée ne dépend pas du type d'inscription
        */
        /**Cette condition se declanche uniquement si la categorie change 
        if (name === "categoriegrilletarifaireId") {
            const selectedOption = event.target.options[event.target.selectedIndex];
            const contenu = selectedOption.getAttribute("contenu");
            if (!contenu || !contenu.toLowerCase().includes('inscription')) {
                $("#typeinscriptionId").addClass("visually-hidden");
                $("#bloc_typeinscription").addClass("visually-hidden");
                $("#typeinscriptionId").attr("required", false);
            } else {
                $("#bloc_typeinscription").removeClass("visually-hidden");
                $("#typeinscriptionId").removeClass("visually-hidden");
                $("#typeinscriptionId").attr("required", true);
            }
            
        }
            */

        let errorData = { ...errors };
        const errorMessage = validateProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...addFormData };
        customerData[name] = event.target.value;
        setAddFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaAddData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    //Une fonction pour vider les champs du formulaire
    const clearForm = () => {
        setAddFormData({
            libelleClasseOption: '',
            descriptionClasseOption: '',
            typeinscriptionId: '',
            classeId: '',
            capacite: '',
        });
    };

    //Submit to save modalAdd
    const handleSubmit = async (event) => {
        event.preventDefault();
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(addFormData,
            schemaAddData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {
            //
            //let isInscription = true 
            //let form = { montantGrilleTarifaire, categoriegrilletarifaireId, classeId, typeinscriptionId, isRequired }
            await GrillestarifairesService.store(addFormData, token).then(response => {
                if (response.data.status === 200) {
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        timer: 3000,
                    });
                    //REdirection
                    navigate(myroutes.grillestarifaires_index)

                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000,
                    });

                }
            }).catch(error => {
                console.log(error);
            })
        }

    }

    //get liste classes
    const fetchClasses = async () => {
        await ClassesService.index(token)
            .then((res) => {
                //console.log(res.data.data)
                setClasses(res.data.data.classes);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    //get Categories grilles tarifaires
    const fetchCategoriesgrillestarifaires = async () => {
        await CategoriesgrillestarifairesService.index(token)
            .then((res) => {
                //console.log(res.data.data)
                setCategoriesgrillestarifaires(res.data.data.categoriesgrillestarifaires)
            })
            .catch((error) => {
                console.log(error);
            });
    }

    //get types inscription
    const fetchTypeInscriptions = async () => {
        await TypesinscriptionsService.index(token)
            .then((res) => {
                //console.log(res.data.data)
                setTypeInscriptions(res.data.data.typesinscriptions)
            })
            .catch((error) => {
                console.log(error);
            });
    }


    useEffect(() => {
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }

        fetchClasses();
        fetchCategoriesgrillestarifaires();
        fetchTypeInscriptions();

    }, [dispatch]);

    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Filarial activeLink={activeLink} />

                <div className="row mb-4 mt-3">
                    {/* Bootstrap Validation */}
                    <div className="col-md">
                        <div className="card shadow-lg">
                            <h5 className="card-header">Enregistrement </h5>
                            <div className="card-body">
                                <Form className="needs-validation" noValidate onSubmit={handleSubmit}>

                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-categorie">Catégories grille <i className="text-danger">*</i></Form.Label>
                                            <Form.Select className="form-select form-select-md" id="select2Basic" name="categoriegrilletarifaireId" value={addFormData.categoriegrilletarifaireId} onChange={handleChange} required>
                                                <option value="" disabled selected>-- Selectionnez une catégorie --</option>
                                                {categoriesgrillestarifaires.length > 0 && categoriesgrillestarifaires.map(item => (
                                                    <option key={item.id} value={item.id} contenu={item.libelleCategorieGrilleTarifaire}>{item.libelleCategorieGrilleTarifaire}</option>
                                                ))}
                                            </Form.Select>
                                            {errors.categoriegrilletarifaireId && (
                                                <div className="alert alert-danger">
                                                    {errors.categoriegrilletarifaireId}
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-md-6 mb-3" id="bloc_typeinscription">
                                            <Form.Label className="form-label" htmlFor="bs-validation-inscription">Type inscription <i className="text-danger">*</i></Form.Label>
                                            <Form.Select className="form-select form-select-md" id="typeinscriptionId" name="typeinscriptionId" value={addFormData.typeinscriptionId} onChange={handleChange} required>
                                                <option value="" disabled selected>-- Selectionnez un type d'inscription --</option>
                                                {typeInscriptions.length > 0 && typeInscriptions.map(item => (
                                                    <option key={item.id} value={item.id}>{item.libelleTypeInscription}</option>
                                                ))}
                                            </Form.Select>

                                            {errors.typeinscriptionId && (
                                                <div className="alert alert-danger">
                                                    {errors.typeinscriptionId}
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-classes">Classe <i className="text-danger">*</i></Form.Label>
                                            <Form.Select className="form-select form-select-md" name="classeId" id="select2Basic" value={addFormData.classeId} onChange={handleChange} required>
                                                <option value="" disabled selected>-- Selectionnez une classe --</option>
                                                {classes.length > 0 && classes.map(item => (
                                                    <option key={item.id} value={item.id}>{item.libelleClasse}</option>
                                                ))}
                                            </Form.Select>
                                            {errors.classeId && (
                                                <div className="alert alert-danger">
                                                    {errors.classeId}
                                                </div>
                                            )}
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <Form.Label className="form-label" htmlFor="bs-validation-montant">Montant <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="form-control" id="bs-validation-montant" name="montantGrilleTarifaire" type="number" max={999999} min={1} value={addFormData.montantGrilleTarifaire} onChange={handleChange}
                                                placeholder="" required />

                                            {errors.montantGrilleTarifaire && (
                                                <div className="alert alert-danger">
                                                    {errors.montantGrilleTarifaire}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <hr className="m-0" />
                                    <div className="row pt-3">
                                        <div className="col-md-6 mb-3">
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="checkbox" id="inlineCheckbox2" name="isRequired" value={addFormData.isRequired} onChange={handleChange} />
                                                <label className="form-check-label" htmlFor="inlineCheckbox2">A payer obligatoirement</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pt-2">
                                        <div className="col-12">
                                            <button type="submit" className="btn btn-primary">Enregistrer</button>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                    {/* /Bootstrap Validation */}

                </div>

            </div>

        </Layout>
    )
}